import { Typography, theme } from 'antd'
import { FormInput } from 'old/components/form-inputs'
import { VerticalContainer } from 'old/components/styled'
import { useField } from 'react-final-form'
import { NullableField, useTranslate, useWindowDimensions }  from 'old/utils'
const  { Title } = Typography

export const TeamMemberProfile = () => {

    //hooks:
    const { __ } = useTranslate()
    const { token: { paddingXXS, marginSM, marginXXS } } = theme.useToken()
    const { SM } = useWindowDimensions()
    const { input: { value: calendarSyn } } = useField('calendarSync')

    return (
        <VerticalContainer style={{ gap: marginSM }}>

            {/* title */}
            <Title
                level={5}
                style={{
                    paddingTop: SM ? 0 : paddingXXS,
                    margin: `${marginXXS}px 0`
                }}
            >
                {__`profile`}
            </Title>
            
            {/* name */}
            <NullableField
                name='name'
                title={__`name`}
                placeholder={__`first_last_name_sample`}
                component={FormInput}
            />
            
            {/* email */}
            <NullableField
                name='email'
                title={__`email`}
                placeholder={__`email_sample`}
                disabled={calendarSyn?.calendarSyncStatus !== null}
                description={calendarSyn?.calendarSyncStatus ? __`to_change_the_email_you_have_to_revoke_the_google_calendar_sync` : null}
                component={FormInput}
            />

            {/* mobile */}
            <NullableField
                name='mobile'
                title={__`mobile`}
                placeholder={__`mobile_sample`}
                component={FormInput}
            />

            {/* description */}
            <NullableField
                name='description'
                title={__`bio`}
                placeholder={__`bio_sample`}
                component={FormInput}
            />

        </VerticalContainer>
    )

}
